module.exports = __webpack_public_path__ + "static/magazine-2-65d03bd11727bf2a88b57411f4a203de.jpg";